export default __webpack_public_path__ + "static/media/support.28d2c2b0.png";